import { SavedCashOutErrors, StakesFromBackend } from './types';

export function transformActiveStakes(savedCashOutErrors?: SavedCashOutErrors) {
  return (data: StakesFromBackend) => ({ activeStakes: data, savedCashOutErrors });
}

